<template>
  <ThemedTextField
    v-model="text"
    outlined
    label="Search area"
    persistent-placeholder
    dense
    @input="onTextChanged(text)"
  />
</template>

<script>
import ThemedTextField from "@/core/ThemedTextField.vue";
export default {
  name: "SearchAreaComponent",
  components: { ThemedTextField },
  data: function () {
    return {
      text: "",
    };
  },
  methods: {
    onTextChanged(text) {
      this.$store.dispatch(
        "weatherRouting/customAreasModule/filterAreasByDescription",
        {
          description: text,
        }
      );
    },
  },
};
</script>
